<div
  class="qrpredisposition-card"
  role="button"
  tabindex="0"
  (click)="openQuestionnaire()"
  (keydown.enter)="openQuestionnaire()"
  (keydown.space)="openQuestionnaire()"
>
  <!-- Info -->
  <div class="qrpredisposition-info">
    <div class="qrpredisposition-info-left">
      <h3 class="qrpredisposition-title">{{ qrpredisposition.title }}</h3>
      <div class="qrpredisposition-meta-item" *ngIf="qrpredisposition.date">
        <span class="qrpredisposition-meta-label">{{ "common.date" | translate }}:</span>
        <span class="qrpredisposition-meta-value">
          {{ qrpredisposition.date | localizedDate: "dd MMMM yyyy" }}
        </span>
      </div>
      <div class="qrpredisposition-result" *ngIf="qrpredisposition.score">
        <div class="score">
          <span class="qrpredisposition-meta-label">{{ "page.home.predispositions.result.score" | translate }}:</span>
          <span class="qrpredisposition-meta-value">{{ qrpredisposition.score }}</span>
        </div>

        <div class="risk-level" *ngIf="qrpredisposition.interpretation">
          <span class="risk-badge">
            {{ qrpredisposition.interpretation.result | translationValue }}
          </span>
        </div>
      </div>
    </div>
    <div class="qrpredisposition-info-right">
      <!-- Status Icon -->
      <mat-icon
        class="qrpredisposition-status-icon"
        [style.color]="qrpredisposition.status | qrStatusColor"
        [matTooltip]="qrpredisposition.status | qrStatusTooltip | translate"
      >
        {{ qrpredisposition.status | qrStatusIcon }}
      </mat-icon>
    </div>
  </div>
</div>
